import React from 'react';
import ProgramsAndTuitionTabs from '@/components/ProgramsAndTuitionTabs';
import ScrollReveal from '@/components/ScrollReveal';

const Tuition = () => {
  return (
    <div className="pt-24 pb-16">
      <ScrollReveal>
        <ProgramsAndTuitionTabs defaultTab="tuition" />
      </ScrollReveal>
    </div>
  );
};

export default Tuition;
